import {authorizationHeaders} from "./api/authorization";

const FILE_DOWNLOAD_PATH_PATTERN = /^\/api\/File\/Download\/(\d+)$/i;

const getPathName = (value: string) => {
    try {
        return new URL(value, window.location.origin).pathname;
    } catch {
        return value.split(/[?#]/)[0];
    }
};

export const resolveFileDownloadId = (value?: string | null): number | undefined => {
    const trimmedValue = value?.trim();
    if (!trimmedValue) {
        return undefined;
    }

    const match = FILE_DOWNLOAD_PATH_PATTERN.exec(getPathName(trimmedValue));
    if (!match) {
        return undefined;
    }

    const id = Number(match[1]);
    return Number.isInteger(id) && id > 0 ? id : undefined;
};

export const buildAuthorizedFileFetchOptions = (authToken?: string): RequestInit => {
    const headers = authorizationHeaders(authToken);
    return headers ? {credentials: "include", headers} : {credentials: "include"};
};
